import React from "react";
import {IProject} from "../../models/interfaces/project.interface.ts";
import {Tab, TabIndicator, TabList, TabPanels, Tabs} from "@chakra-ui/react";
import SubtitlesTranscreationFeatureProgress from "./SubtitlesTranscreationFeatureProgress.tsx";
import SingleFeatureProgress from "./singleFeatureProgress.tsx";
import AudioDescriptionFeatureProgress from "./AudioDescriptionFeatureProgress.tsx";
import {camelCaseToTitleCase} from "../../utils/utils.ts";

interface ProjectDrawerFeaturesProgressProps {
  project: IProject;
}

const ProjectDrawerFeaturesProgress: React.FC<ProjectDrawerFeaturesProgressProps> = ({project}: ProjectDrawerFeaturesProgressProps) => {
  const projectFeaturesExists: Record<string, boolean> = {
    subtitlesTranscreation: true,
    dialogueList: !!project.featuresStates?.dialogueList,
    extendedMetadata: !!project.featuresStates?.extendedMetadata,
    audioDescriptions: !!project.featuresStates?.audioDescriptions,
  }

  return (
    <div className="flex flex-col mt-6 ">
      <Tabs position='relative' variant="unstyled">
        <TabList>
          {
            Object.keys(projectFeaturesExists).filter((key: string) => projectFeaturesExists[key]).map((key: string) => {
              return <Tab key={key}>{camelCaseToTitleCase(key)}</Tab>;
            })
          }
        </TabList>
        <div className="w-full bg-n-500 h-[1px]"/>
        <TabIndicator mt='-1.5px' height='2px' bg='brandPurple.500' borderRadius='1px' zIndex={10}/>
        <TabPanels>
          <SubtitlesTranscreationFeatureProgress project={project}/>
          <SingleFeatureProgress
            projectId={project.id}
            projectName={project.name}
            feature={project.featuresStates.dialogueList}
            featureName={"dialogueList"}
          />
          <SingleFeatureProgress
            projectId={project.id}
            projectName={project.name}
            feature={project.featuresStates.extendedMetadata}
            featureName={"extendedMetadata"}
          />
          <AudioDescriptionFeatureProgress project={project}/>
        </TabPanels>
      </Tabs>
    </div>
  )
}

export default ProjectDrawerFeaturesProgress;